import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Injectable()
export class RSAMomentDateAdapter extends MomentDateAdapter {
  public format(date: Moment, displayFormat: string): string {
    date = this.clone(date);
    if (!this.isValid(date)) {
      throw Error('MomentDateAdapter: Cannot format invalid date.');
    }
    return date.format('DD/MM/YYYY');
  }
}
